import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Location } from '../types';

import { locationsKeys } from './query-keys';

export async function getLocations(): Promise<Location[]> {
  return mediaManagerClient.get('/api/v1/locations').then(({ data }) => data);
}

type QueryFnType = typeof getLocations;

interface UseLocationParams {
  config?: QueryConfig<QueryFnType>;
}

export function useLocations({ config = {} }: UseLocationParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: locationsKeys.all,
    queryFn() {
      return getLocations();
    },
  });
}
